<template>
  <div class="pa-6">
    <div class="mb-6">
      <h2 class="text-h5 font-weight-bold mb-2">Password</h2>
      <p class="text-grey-darken-1">{{ $t("components.UserSettingsPage.change_password_info") }}</p>
    </div>

    <div class="mb-6">
      <change-password :user-id="userId" />
    </div>

    <v-divider class="my-6" />

    <div>
      <h3 class="text-h6 font-weight-bold mb-2">{{ $t("components.UserSettingsPage.two_factor_auth") }}</h3>
      <p class="text-grey-darken-1 mb-4">{{ $t("components.UserSettingsPage.two_factor_auth_warning") }}</p>
      <two-factor-auth />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useGlobalStore } from "@/store";
import { FrontendUser } from "@YenzaCT/sdk";
import TwoFactorAuth from "@/pages/Settings/UserSettingsPage/components/TwoFactorAuth.vue";
import ChangePassword from "@/pages/Settings/UserSettingsPage/components/ChangePassword.vue";

const store = useGlobalStore();
const user = computed(() => store.user as FrontendUser);
const userId = user.value._id;
</script>
